module.exports = __webpack_public_path__ + "img/5-2.bb3a8160.svg";